<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2">
            <div class="enquete-container">
                <div class="enquete-header">
                    <p class="enquete-header__title">Enquete</p>
                    <p class="enquete-header__subtitle enquete-header__subtitle--green">{{value.title}}</p>
                </div>

                <div class="enquete-options" v-if="!voted">
                    <form>
                        <div class="radio-wrapper" v-for="answer in value.answers" :key="answer.id">
                            <input type="radio" :id="`poll-${answer.id}`" name="enquete" :value="answer.id" v-model="selected">
                            <label :for="`poll-${answer.id}`">{{answer.title}}</label>
                        </div>
                    </form>
                </div>

                <div class="enquete-results" v-if="voted">
                    <div class="enquete-results__item" v-for="answer in value.answers" :key="answer.id">
                        <p class="results-name">{{answer.title}}</p>
                        <span class="results-bar" :style="`width: ${percentage(answer.votes)}%`">{{percentage(answer.votes)}}%</span>
                    </div>
                </div>

                <div class="enquente-actions">
                    <a :class="{'btn-result':true, 'disabled':voted}" @click.prevent="voted=true" href="#">Ver resultado</a>
                    <a :class="{'btn-vote':true, 'disabled':voted}" @click.prevent="vote" href="#">Votar</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api'

export default {
    name: 'Poll',
    props:['value'],
    data() {
        return {
            selected: null,
            voted: false,
        }
    },
    computed:{
        total: function () {
            return this.value.answers.reduce((prev, cur) => {
                return prev + cur.votes
            }, 0)
        }
    },
    methods:{
        percentage (votes) {
            if (!votes) return 0
            let num = (votes / this.total) * 100
            return Math.round((num + Number.EPSILON) * 100) / 100
        },
        update () {

        },
        async vote () {
            const response = await api.post(`answer/${this.selected}/vote/`)

            if (response.ok) {
                for (let i in this.value.answers) {
                    let answer = this.value.answers[i]

                    if (answer.id == this.selected) {
                        answer.votes++   
                    }
                }
                this.voted = true
            }
        }
    }
}
</script>